const login = {
  login: '登录',
  phone: '手机',
  email: '邮箱',
  erCode: '二维码',
  phoneNo: '手机号',
  sryx: '请输入邮箱',
  password: '密码',
  wjmm: '忘记密码？',
  srmm: '请输入密码',
  myzh: '还没有账号？',
  ljzc: '立即注册',
  cxsm: '刷新后使用biking App 重新扫码',
  xydl: '请在手机上响应登录',
  smewm: '在Biking App 点击个人资料图标，然后按右上角的图标扫描二维码',
  qtfs: '其他方式登入',
  ggsfyz: '谷歌身份验证',
  bdsj: '你已绑定手机',
  bdyx: '你已绑定邮箱',
  fsyzm: '发送验证码',
  wcyz: '请完成验证',
  dlcg: '您已登录成功，biking欢迎您！',
  bktb: '出于安全考虑，账户安全设置修改后的24小时内不可提币',
  fhdl: '返回登录页面',
  jx: '继续',
  cxfs: '重新发送',
  gxmm: '更新密码',
  srsjh: '请输入手机号',
  wjmm1: '忘记密码',
  sryxdz: '请输入邮箱地址',
  srzqyx: '请输入正确的邮箱地址',
  sryzm: '输入验证码',
  czmm: '重置密码',
  sbdyzm: '收不到验证码？',
  srxmm: '请输入新密码',
  zczh: '注册Biking账号',
  yqm: '邀请码（选填）',
  sryqm: '请输入邀请码',
  zc: '注册',
  yyzh: '已有账号？',
  ljdl: '立即登录',
  fsz: '验证码已发送至',
  next: '下一步',
  szmm: '设置密码',
  submit: '提交',
  zccg: '注册成功！'
}
const download = {
  title: '多元化游戏及<br/>数字货币交易平台',
  subTitle: '币王可进行多达百种数字货币交易',
  xzbw: '为什么选择币王',
  czzz: 'BiKing助您创造、增值及保管财富',
  download: 'App Store 下载',
  downloadtf: 'TestFlight下载',
  cjqxz: '超级签下载',
  cjq: '超级签{index}',
  bdxz: '本地下载',
  ggpxz: 'Google Play 下载',
  advantageTitle1: '顶级性能 · 极速交易',
  subTitleSubTitle1: '伦敦证券交易所技术驱动，超低延迟，极速撮合',
  advantageTitle2: '资产保障 · 极致安全',
  subTitleSubTitle2: '币王符合CCSS标准，保障资产及数据安全',
  advantageTitle3: '全天候服务',
  subTitleSubTitle3: '保证系统正常运行，提供全天候客户服务',
  qhidxq: '切换ID详情介绍',
  step1: '第一步',
  step2: '第二步',
  step3: '第三步',
  step4: '第四步',
  step5: '第五步',
  step6: '第六步',
  step7: '第七步',
  step8: '第八步',
  step9: '第九步',
  step10: '第十步',
  azBiking: '通过App Store安装BiKing',
  dlxz: '如果您拥有非大陆地区的App ID,请直接登录App Store下载',
  fdlid: '准备一个非大陆地区App ID',
  yxfshq: '如果您没有非大陆地区的App ID,可以尝试通过以下方式获取',
  qhid: '在App Store切换Apple ID',
  dk: '1.打开',
  ysjtx: 'App Store应用,点击App Store右上角的头像',
  cxsrmm: '2.点击退出登录,重新输入Apple ID及密码',
  wfdl: '* 如果提示“无法登录”,有可能是您近期切换登录频率太高,可以更换ID或者几个小时之后重试。如果ID被锁定,则需要进行验证或更换ID再试',
  azapp: '安装App',
  storesh: '1.登录成功后,会自动跳转至D对应地区的 App Store,在App Store中搜索“BiKing”,点击“Get"按钮,开始安装App',
  jxxz: '我有非大陆苹果ID，继续下载',
  jxxz1: '继续下载',
  way1: '方式一',
  wayTitle1: '自己注册,安全稳定',
  wayBtn1: '查看如何注册',
  way2: '方式二',
  wayTitle2: '平台参考ID（方便快捷）',
  wayBtn2: '查看参考ID',
  way3: '方式三',
  wayTitle3: '国家地区的引导（自由切换）',
  wayBtn3: '查看如何购买',

  ckzh: '非中国大陆Apple ID 参考账户',
  jgck: '以下海外地区ID供参考使用',
  jjfz: '(点击账户或密码可直接复制)',
  zh: '账户',
  mm: '密码',
  xxxl: '为了防止您的手机信息泄露',
  dlicloud: '请务必不要使用上方的Apple ID登录ICloud',
  tczh: '使用参考Apple ID 下载过App后,请及时退出该账号',
  cfsy: '请不要绑定手机号，不然ID将无法重复使用',
  jrql: '扫一扫二维码加入群聊',
  lxkf: '联系客服',

  zjzc: '自己注册海外ID',
  registerStep1: '第一步 打开appleid首页',
  registerStep2: '第二步 验证邮箱',
  registerStep3: '第三步 退出App Store账号',
  registerStep4: '第四步 在Store登入刚注册的ID',
  gwzcwz: '在Safari浏览器内打开苹果官网注册网址：',
  yzdzyx: '填写完所有的信息点击继续之后，这时会收到一封验证 Apple ID的电子邮件，需要把邮箱验证码填写上去。',
  tjfkfs: '随后就会它会自动跳转到Apple ID的管理页面（可能会要 加载一会儿）进入到管理页面后，点击付款和送货，并在 接下来的页面中点击添加付款方式。',
  mgsfzsc: '到了最关键的时刻了，确认付款方式是不是“无”，如果是 “无”就不要动了国家或地区是不是美国或者你想注册的地 区，其他内容都可以随便填。但是最好填写英文，省/市选 择阿拉斯加，因为这个地区可以免税，购买App也可以免 税。具体的个人信息填写可以通过网站生成：美国身份证生 成',
  gxdqxx: '填写完成后点击更新，更新地区信息。',
  zhxx: '1、进入App Store，点击右上方的头像，进入到账户页面',
  djwc: '2、滑动该页面至底部，点击“退出登录”即可退出商店ID 再点击”完成”',
  jrzhdl: '1、再次点击右上角的头像，进入账号登录页面',
  zhmmdl: '2、输入账号、密码，点击“登录”，进行登录',
  jydlcg: '3、输入验证码，成功检验后，即登录成功Apple ID',
  jysssd: '交易随时随地',
  smewm: '扫描二维码',
  xiazai: '下载',
  huodong: '活动',
  title1: 'Biking 多元化游戏',
  title2: '及数字货币交易平台',
  open: '在“Biking”App中打开',
  ggzx: '公告中心',
  lscb: '链上充币',
  fbrj: '法币入金',
  tgaq: '致力于为用户提供更为安全',
  wdjmzc: '稳定的加密资产衍生品交易服务',
  szhbjy: '数字货币交易我们是专业的',
  yxhsjh: '通过电子邮箱/手机号码注册',

  appBetaTag: 'BETA版正式上线',
  appHeroTitle: 'App全新升级',
  appHeroSubtitle: '开启 Biking 交易新航线',
  tryNow: '立即体验',
  downloadBikingApp: '下载 Biking App',
  roadmapStageMeta: '/{total} {phase}',
  roadmapPhase1: '第一阶段',
  roadmapPhase2: '第二阶段',
  roadmapPhase3: '第三阶段',
  roadmapPhase4: '第四阶段',
  roadmapPhase5: '第五阶段',
  roadmapVisionTitle: '视觉重构',
  roadmapVisionDesc: '全新设计语言 · 极致交互体验 · 沉浸式界面',
  roadmapVisionPoint1: '全新设计语言',
  roadmapVisionPoint2: '极致交互体验',
  roadmapVisionPoint3: '沉浸式界面',
  roadmapEngineTitle: '性能引擎升级',
  roadmapEngineDesc: '底层架构重构 · 毫秒级响应 · 极致稳定性',
  roadmapEnginePoint1: '底层架构重构',
  roadmapEnginePoint2: '毫秒级响应',
  roadmapEnginePoint3: '极致稳定性',
  roadmapBetaTitle: 'Beta 开启',
  roadmapBetaDesc: '新一代交易系统 · 极速撮合 · 限时体验',
  roadmapBetaPoint1: '新一代交易系统',
  roadmapBetaPoint2: '极速撮合',
  roadmapBetaPoint3: '限时体验',
  roadmapGlobalTitle: '平台全面进化',
  roadmapAiTitle: 'AI 交易时代',
  comingSoon: '敬请期待',
  appCopyright: '© 2016-2026 BiKing 版权所有',
  testFlight: 'Test Flight',
  appStore: 'App Store',
  googlePlay: 'Google Play',
  superSign: '超级签',
  chooseDownload: '选择下载方式',
  downloadAddr1: '下载地址1',
  downloadAddr2: '下载地址2',
  downloadCancel: '取消',
  apkLocalDownload: '本地下载 APK',
  entryBetaTitle: 'Beta 版本已开放',
  entryBetaSubtitle: '体验最新功能，抢先尝鲜',
  entryBetaTitleFull: 'Beta 版本已开放，体验最新功能，抢先尝鲜！',
  entryDownloadNow: '立即下载',
  entryTagNew: 'New',
  entryClose: '关闭',
}
export {login, download}


// WEBPACK FOOTER //
// ./src/i18n/lang/login/zh.js